<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-card
    flat
    class="secondary fill-height pa-12"
    height="25%">
    <v-subheader class="display-1 grayBold--text">
      {{$t("delete_installation")}}
    </v-subheader>
    <v-list class="secondary card-content" max-height="80vh" min-width="400px">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="subtitle-2 grayBold--text">
            {{$t("delete_installation_warning")}}{{payload.installation.tag_id.split('_').pop()}}{{$t("question_mark")}} 
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        depressed
        right
        light
        color="grayBold--text secondary"
        @click="hideModal()"
      >
        {{$t("cancel")}} 
      </v-btn>
      <v-btn
        color="primary"
        depressed
        right
        large
        class="modal-logout"
        :loading="isDeletingInstallation"
        @click="doDeleteInstallation"><v-icon left>mdi-delete</v-icon>{{$t("delete_for_uppercase")}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule, devicesModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteInstallationModal extends Vue {
  @Prop()
  payload!: any;

  isDeletingInstallation = false;

  async mounted() {
    commonModule.initSnackbar({});
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async hideSideView() {
    commonModule.hideSideview();
  }

  async doDeleteInstallation () {
    this.isDeletingInstallation = true;
    await installationsModule.deleteInstallation(this.payload.installation);
    this.hideModal();
    devicesModule.unsetCurrentDevice();
    installationsModule.unsetCurrentInstallation();
    this.hideSideView();
  }
};
</script>
<style scoped lang="scss">
.card-content {
  overflow: auto;
}
</style>
